/**
 * The superMenu is a list of all the pages and sections on the site.
 * It is used to generate the navbar and the sidebar.
 * It is also used to generate the breadcrumbs.
 * It is also used to generate the footer.
 * It is also used to generate the sitemap.
 * It is also used to generate the robots.txt.
 * It is also used to generate the manifest.json.
 * It is also used to generate the .env.local.
 *
 * Do NOT export superMenu from this file, use getters instead.
 */

import type { Metadata } from "next"
import { superMenu } from "./data"

export const getPrimaryMenuItems = () => {
  return superMenu
}

export const getPrimaryMenuHrefs = () => {
  return superMenu.map(item => item.href)
}

export const getPrimaryMenuKeys = () => {
  return superMenu.map(item => item.key)
}

export const getMenuItemByPathname = (pathname: string) => {
  return superMenu.find(item => item.href === pathname)
}

// private function
const getSubPageByPathname = (pathname: string) => {
  for (const item of superMenu) {
    if (item.subPages) {
      const subPage = item.subPages.find(sub => sub.href === pathname)
      if (subPage) return subPage
    }
  }
  return null
}

export const generateMetadataFromMenu = (pathname: string): Metadata => {
  const menuItem =
    getMenuItemByPathname(pathname) || getSubPageByPathname(pathname)

  // Use home page as fallback
  // TODO: Explain this better
  const homeItem = superMenu.find(item => item.key === "home")!
  const fallbackItem = menuItem || homeItem

  // Build title based on the menu item
  const title =
    fallbackItem.key === "home"
      ? `agnos.ai - ${fallbackItem.description.split("—")[0].trim()}`
      : `${fallbackItem.label} - agnos.ai`

  return {
    title,
    description: fallbackItem.description,
  }
}

export function getPageTypeNameFromPath(path: string): string {
  // Try to match a subPage first
  const subPage = getSubPageByPathname(path)
  if (subPage) {
    return `${subPage.label} page`
  }
  // Then try to match a primary menu item
  const menuItem = getMenuItemByPathname(path)
  if (menuItem) {
    return `${menuItem.label} page`
  }
  return "page"
}
